<template>
  <div class="uk-container">
    <appointment-info :appointment-id="$route.params.id">
      <template v-if="!isDentist && appointment.info.status !== 2" v-slot:footer>
        <router-link
          v-if="needsPayment"
          :to="{ name: 'appointment-update', params: { id: appointment.id }, query: { type: 'payment' } }"
          class="uk-button uk-button-primary uk-margin-small-right"
          :class="{ 'uk-button-small' : needsPayment }"
        >
          Update Payment
        </router-link>

        <template v-if="editable">
          <router-link
            tag="button"
            :to="{ name: 'appointment-update', params: { id: appointment.id }, query: { type: 'dentist' } }"
            class="uk-button uk-button-primary uk-margin-small-right"
            :class="{ 'uk-button-small' : needsPayment }"
          >
            Update {{ (needsPayment) ? 'Appointment' : '' }}
          </router-link>
          <router-link
            :to="{ name: 'appointment-cancel', params: { id: appointment.id } }"
            class="uk-button uk-button-danger"
            :class="{ 'uk-button-small uk-margin-small-top' : needsPayment }"
          >
            Cancel
          </router-link>
        </template>

        <template v-else>
          <div class="uk-alert uk-alert-warning">
            It is not possible to <b>Update</b> or <b>Cancel</b> the appointment because it is in the past.
          </div>
        </template>
      </template>
    </appointment-info>

    <appointment-history v-if="!isDentist && appointment.log.length > 1" :log="appointment.log" />
  </div>
</template>

<script>
import AppointmentInfo from '@/components/appointment/Info.vue'
import AppointmentHistory from '@/components/appointment/History.vue'
import nowMixin from '@/utils/mixins/now'

export default {
  name: 'ViewAppointmentSingle',

  components: { AppointmentInfo, AppointmentHistory },

  mixins: [nowMixin],

  computed: {
    appointment() {
      return this.$route.params.id ? this.$store.getters['appointments/find'](this.$route.params.id) : null
    },

    isDentist() {
      return this.$store.getters['account/type'] === 'dentist'
    },

    needsPayment() {
      return this.appointment.payment.status === 'requires_payment_method'
    },

    editable() {
      const check = {
        date: true,
        bit: true
      }

      // If the appointment date is earlier than today - Cannot Change
      if (this.appointment.dentist.data[this.appointment.info.dentist].date < this.now.date.t) {
        check.date = false
      }

      // If date is today and the time bit is the past - Cannot Change
      if (this.appointment.dentist.data[this.appointment.info.dentist].date === this.now.date.t && this.appointment.dentist.data[this.appointment.info.dentist].bit <= this.now.time.id) {
        check.bit = false
      }

      return check.date && check.bit
    }
  },

  beforeMount() {
    this.checkReadStatus()
  },

  beforeUpdate() {
    this.checkReadStatus()
  },

  methods: {
    checkReadStatus() {
      // Mark as read if all conditions are fulfilled
      // IF user is dentist AND IF appointment was not read before
      if (this.isDentist && !this.appointment.dentist.data[this.$store.state.account.profile.dentist].read) {
        this.$store.dispatch('appointments/setRead', { id: this.appointment.id, status: true })
      }
      // Possible additional check: this.appointment.dentist.list.includes(this.$store.state.account.profile.dentist)
      // To see if the user is a member of the dentist practice
      // This should be covered by Vuex Store, which filters appointments to include only matching appointments for the user
    }
  }
}
</script>
